import "core-js/modules/web.dom-exception.stack.js";
const CHOSEN_COUNTRY_LANG = 'chosenCountryLang';

// A mimic of the html5 storage objects
class FakeStorage {
  data = {};
  getItem(key) {
    return this.data[key];
  }
  removeItem(key) {
    delete this.data[key];
  }
  setItem(key, value) {
    this.data[key] = value;
  }
  clear() {
    this.data = {};
  }
  get length() {
    return Object.keys(this.data).length;
  }
}

// MDN recommended function to check browser storage availability, with small adjustment for Android
// https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
const _verifyStorage = (local = false) => {
  let storage;
  try {
    storage = window[local ? 'localStorage' : 'sessionStorage'];
    const x = '__storage_test__';

    // Extra check
    if (storage === null || storage === undefined) {
      return false;
    }
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return e instanceof DOMException && (
    // everything except Firefox
    e.code === 22 ||
    // Firefox
    e.code === 1014 ||
    // test name field too, because code might not be present
    // everything except Firefox
    e.name === 'QuotaExceededError' ||
    // Firefox
    e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
    // acknowledge QuotaExceededError only if there's something already stored
    storage && storage.length !== 0;
  }
};

// Setup objects for local and session storage
const local = _verifyStorage(true) ? window.localStorage : new FakeStorage();
const session = _verifyStorage(false) ? window.sessionStorage : new FakeStorage();
export const setObject = (key, value) => {
  local.setItem(key, JSON.stringify(value));
};
export const getObject = key => {
  const value = local.getItem(key);
  return value && JSON.parse(value);
};
export const removeObject = key => {
  local.removeItem(key);
};
export const setSessionObject = (key, value) => {
  session.setItem(key, JSON.stringify(value));
};
export const getSessionObject = key => {
  const value = session.getItem(key);
  return value && JSON.parse(value);
};
export const removeSessionObject = key => {
  session.removeItem(key);
};
export const clearSession = () => {
  session.clear();
};
export const clearSessionArray = keysToRemove => {
  keysToRemove.forEach(k => session.removeItem(k));
};
export const updateChosenCountry = country => {
  const current = getObject(CHOSEN_COUNTRY_LANG) || {};
  current.country = country;
  setObject(CHOSEN_COUNTRY_LANG, current);
};
export const updateChosenLang = language => {
  const current = getObject(CHOSEN_COUNTRY_LANG) || {};
  current.language = language;
  setObject(CHOSEN_COUNTRY_LANG, current);
};
export const updateChosenCountryLang = (country, lang) => {
  updateChosenCountry(country);
  updateChosenLang(lang);
};
export const getCurrentCountry = () => {
  const current = getObject(CHOSEN_COUNTRY_LANG);
  return current && current.country;
};
export const getCookie = key => {
  const nameEQ = key + '=';
  const ca = window.document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      const value = c.substring(nameEQ.length, c.length);
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
  }
  return null;
};
export const setCookie = (key, value, time = 86400000) => {
  let expires = '';
  if (time) {
    const date = new Date();
    date.setTime(date.getTime() + time);
    expires = '; expires=' + date.toUTCString();
  }
  const jsonValue = JSON.stringify(value);
  window.document.cookie = key + '=' + (jsonValue || '') + expires + '; path=/';
};
export const clearCookie = key => {
  window.document.cookie = key + '=; Max-Age=-99999999;';
};
export default {
  clearCookie,
  clearSession,
  getCookie,
  getObject,
  getSessionObject,
  removeObject,
  removeSessionObject,
  setCookie,
  setObject,
  setSessionObject
};